import { FC, ReactNode } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Drawer.style.css";
import closeIcon from "../../assets/images/closeIcon.svg";
import CarStatus from "../CarStatus/CarStatus";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  title: any;
  subtitle?: string;
  status?: string;
  titleStyle?: React.CSSProperties;
  revertedDraft? : string
}

const Drawer: FC<DrawerProps> = ({
  isOpen,
  onClose,
  children,
  title,
  subtitle,
  status,
  titleStyle,
  revertedDraft
}) => {
  const titleClass =
    title === "2024-XXXXXX-01" ? "gray-title" : "default-title";

  return (
    <Offcanvas show={isOpen} onHide={onClose} placement="end" backdrop={false}>
      <Offcanvas.Header style={{ padding: 10 }}>
        <Offcanvas.Title className={`offcanvas-title ${titleClass}`}>
        <div>
              <div className="d-flex gap-3">
                   <p className="offcanvas-title">{title}</p>
                    {status &&  <CarStatus status={status} revertedDraft={revertedDraft}/>}
              </div>
              <h1 className="offcanvas-subtitle">{subtitle}</h1>
            </div>
        </Offcanvas.Title>
        <img
          src={closeIcon}
          alt="Close"
          className="close-btn"
          onClick={onClose}
        />
      </Offcanvas.Header>

      <hr className="mt-0 divider" />
      <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default Drawer;
